import React from 'react';
import { Routes, Route } from 'react-router-dom';
import App from '@/App';
import OpenHousePage from '@/pages/OpenHousePage';
import OpenHouseQRPage from '@/pages/OpenHouseQRPage';
import SellerLandingPage from '@/pages/SellerLandingPage';
import BlogIndexPage from '@/pages/BlogIndexPage';
import BlogPostPage from '@/pages/BlogPostPage';
import LeadsDashboard from '@/pages/LeadsDashboard';
import AccountPage from '@/pages/AccountPage';
import LandingPage from '@/pages/LandingPage';
import { LANDING_PAGES } from '@/constants/landingPages';

export const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<App />} />
    <Route path="/home-value" element={<SellerLandingPage />} />
    <Route path="/sell/:slug" element={<SellerLandingPage />} />
    <Route path="/blog" element={<BlogIndexPage />} />
    <Route path="/blog/:slug" element={<BlogPostPage />} />
    <Route path="/open-house" element={<OpenHousePage />} />
    <Route path="/open-house/qr" element={<OpenHouseQRPage />} />
    <Route path="/account" element={<AccountPage />} />
    <Route path="/admin/leads" element={<LeadsDashboard />} />
    {LANDING_PAGES.map((pg) => (
      <Route key={pg.slug} path={`/${pg.slug}`} element={<LandingPage />} />
    ))}
    <Route path="*" element={<App />} />
  </Routes>
);
